import { IssueStatus } from 'shared'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { useEditIssueModalIssueTypesQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useGlobalState } from 'context/GlobalStateContext'
import { HelpMessage } from 'utils/constants'
import { Issue } from '../../../../../../IssueTrackerContext/types'
import { useDisabledOptions } from 'hooks/useDisabledOptions'

const IssueTypes: React.VFC<Pick<Issue, 'statusId'>> = ({ statusId }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { data, loading } = useEditIssueModalIssueTypesQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const [disabled, { some }] = useDisabledOptions([
    {
      disabled: statusId === IssueStatus.PendingClosure.id,
      reason: {
        why: 'invalid status',
        statusName: IssueStatus.PendingClosure.name,
      },
    },
    {
      disabled: statusId === IssueStatus.Closed.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Closed.name },
    },
    {
      disabled: statusId === IssueStatus.Unlocked.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Unlocked.name },
    },
  ])
  return (
    <CIMSFormItem
      label="Types"
      name="types"
      help={HelpMessage.Issues.IssueTracker.Types}
      requiredMessage={
        statusId !== IssueStatus.Draft.id
          ? 'Please enter at least one type'
          : undefined
      }
      disabled={disabled}
    >
      <CIMSSelect
        multiple
        loading={loading}
        options={useOptions({
          items: data?.issueTypes?.records,
          sort: 'name',
          label: 'name',
          value: 'id',
          tooltip: 'description',
        })}
        disabled={some}
      />
    </CIMSFormItem>
  )
}

export default IssueTypes
